const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://trajetus.net';

// Função para obter o token do localStorage
const getAuthToken = () => {
  return localStorage.getItem('token');
};

// Função para criar headers com autenticação
const getAuthHeaders = () => {
  const token = getAuthToken();
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

class TipoDespesaService {
  // Listar todos os tipos de despesa
  async listarTodos() {
    try {
      const response = await fetch(`${API_BASE_URL}/api/tipos-despesa`, {
        method: 'GET',
        headers: getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao listar tipos de despesa:', error);
      throw error;
    }
  }

  // Listar tipos de despesa por usuário
  async listarPorUsuario(id_usuario) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/tipos-despesa/usuario/${id_usuario}`, {
        method: 'GET',
        headers: getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao listar tipos de despesa por usuário:', error);
      throw error;
    }
  }

  // Buscar tipo de despesa por ID
  async buscarPorId(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/tipos-despesa/${id}`, {
        method: 'GET',
        headers: getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao buscar tipo de despesa:', error);
      throw error;
    }
  }

  // Criar novo tipo de despesa
  async criar(dadosTipoDespesa) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/tipos-despesa`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(dadosTipoDespesa),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao criar tipo de despesa:', error);
      throw error;
    }
  }

  // Atualizar tipo de despesa
  async atualizar(id, dadosTipoDespesa) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/tipos-despesa/${id}`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify(dadosTipoDespesa),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao atualizar tipo de despesa:', error);
      throw error;
    }
  }

  // Excluir tipo de despesa
  async excluir(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/tipos-despesa/${id}`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao excluir tipo de despesa:', error);
      throw error;
    }
  }
}

export default new TipoDespesaService();